import(/* webpackMode: "eager", webpackExports: ["default"] */ "/build/0e8b5f2d-3f0e-4da6-968a-f459394a8237/src/components/layout/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/build/0e8b5f2d-3f0e-4da6-968a-f459394a8237/src/design-system/layout/Main.tsx");
